$(document).on('show.bs.collapse', '.collapse.collapsible-list', () => $('.collapsible-list-toggler').addClass('toggling'));

$(document).on('shown.bs.collapse', '.collapse.collapsible-list', () => $('.collapsible-list-toggler').removeClass('toggling').addClass('toggled'));

$(document).on('hide.bs.collapse', '.collapse', () => $('.collapsible-list-toggler').removeClass('toggled').addClass('toggling'));

$(document).on('hidden.bs.collapse', '.collapse', () => $('.collapsible-list-toggler').removeClass('toggling'));
